<template> 
    <div 
      :style="{
        cursor: 'url(' + pointerCursor + ', auto',
        height: imgRescaledSize[1] + 'px', 
        width: imgRescaledSize[0] + 'px',
        }"
      >
        
        <div 
            v-for="(item, index) in doors"
            :key="item.name"
            >
            <div class="container-fluid">
              <router-link :to="String(item.url)">
                  <svg
                    :xmlns="svgFiles[index].xmlns"
                    :height="svgFiles[index].size[1]"
                    :width="svgFiles[index].size[0]"
                    :viewBox="svgFiles[index].viewBox"
                    fill="none"
                    :style="{ 
                        position: 'absolute',
                        left: svgFiles[index].position[0] + 'px',
                        top: svgFiles[index].position[1] + 'px', 
                        zIndex: 0,
                        cursor: 'url(' + pointerCursor + '), pointer'
                        }">
                    <path 
                        @mouseenter="toggleDoorVisible(index)" 
                        @mouseleave="toggleDoorVisible(index)"
                        :style="{ 
                            pointerEvents: 'all',
                            cursor: 'url(' + clickCursor + '), pointer'
                            }"
                        fill="none" 
                        :d="svgFiles[index].path" 
                        />
                  </svg>
              </router-link>
            </div>
        </div>
        <div class="container-fluid"
            rel="preload"
            :style="{ 
                backgroundImage: 'url(' + image.src + ')', 
                position: 'absolute', 
                pointerEvents: 'none', 
                height: imgRescaledSize[1] + 'px', 
                width: imgRescaledSize[0] + 'px',
                backgroundSize: imgRescaledSize[0] + 'px ' + imgRescaledSize[1] + 'px',
                top: 0,
                left: 0
                }">
            </div>
        <div 
            v-for="(item, index) in doors"
            :key="item.url"
            >
            <div class="container-fluid bg-img-on" v-if="isDoorVisible[index]"
                rel="preload"
                :style="{ 
                  backgroundImage: 'url(' + doorImages[index].src + ')', 
                  position: 'absolute', 
                  pointerEvents: 'none', 
                  height: imgRescaledSize[1] + 'px', 
                  width: imgRescaledSize[0] + 'px', 
                  backgroundSize: imgRescaledSize[0] + 'px ' + imgRescaledSize[1] + 'px',
                  top: 0,
                  left: 0
                }">
            </div>
        </div>
        <transition name="fade">
          <div 
            v-if="showLabels" 
            class="container-fluid overlay"
            rel="preload"
            :style="{ 
                  position: 'absolute', 
                  pointerEvents: 'none', 
                  height: imgRescaledSize[1] + 'px', 
                  width: imgRescaledSize[0] + 'px',
                  backgroundSize: imgRescaledSize[0] + 'px ' + imgRescaledSize[1] + 'px',
                  top: 0,
                  left: 0
                  }"
          ></div>
        </transition>
    </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: "BackgroundImage",
  props: ["galleries", "name", "showLabels", "backgroundImg"],
  data: function() {
    return {
      imgHeight: window.innerHeight,
      imgWidth: window.innerWidth,
      svgSizes: [],
      isDoorVisible: [],
      pointerCursor: require('@/assets/cursors/magnify.svg'),
      clickCursor: require('@/assets/cursors/pointer.svg'),
      imgRescaledSize: [],
      scale: [1, 1],
      doorImages: [],
      svgFiles: [],
      image: null
    };
  },
  methods: {
    toggleDoorVisible(index) {
      this.isDoorVisible.splice(index, 1, !this.isDoorVisible[index])
    },
    setScaling() {
      let imgSizeRatio = (this.imgSize[0]/this.imgSize[1]);
      let screenRatio = window.innerWidth/window.innerHeight;
      let modHeight = this.imgSize[1] * (window.innerWidth/this.imgSize[0]);
      let modWidth = this.imgSize[0] * (window.innerHeight/this.imgSize[1]);
      let height = ((screenRatio > imgSizeRatio) ? modHeight : window.innerHeight);
      let width = ((screenRatio > imgSizeRatio) ? window.innerWidth : modWidth);
      this.imgRescaledSize = [width, height];
      this.scale = [width/this.imgSize[0], height/this.imgSize[1]];
    },
    setSvgSizePos(index) {
      let pos = this.galleries["galleries"][this.name][0]["doors"][index]["mask"]["position"];
      let size = this.galleries["galleries"][this.name][0]["doors"][index]["mask"]["size"];
      let sizeX = size[0] * this.scale[0];
      let sizeY = size[1] * this.scale[1];
      // let newX = pos[0] * this.scale[0] - 0.5*sizeX;
      // let newY = pos[1] * this.scale[1] - 0.5*sizeY;
      let newX = pos[0] * this.scale[0];
      let newY = pos[1] * this.scale[1];
      this.svgFiles[index].size = [sizeX, sizeY];
      this.svgFiles[index].position = [newX, newY];
    },
    updateSvgsSizePos() {
      this.setScaling();
      for (let i = 0; i < this.doors.length; i++) {
        this.setSvgSizePos(i);
      }
    },
    loadDoorImages() {
      for (let i = 0; i < this.galleries["galleries"][this.name][0]["doors"].length; i++) {
        let img = new Image();
        img.onload = function () {
        };
        img.src = require("@/assets/galleries/" + this.galleries["galleries"][this.name][0]["doors"][i]["image"]);
        this.doorImages.push(img);
      }
    },
    loadImage() {
      this.image = new Image();
      this.image.src = require("@/assets/galleries/" + this.galleries["galleries"][this.name][0]["image"]);
      this.image.onload = function () {
      };
    },
    loadSvgs() {
      for (let i = 0; i < this.doors.length; i++) {
        let curSvg = JSON.parse(JSON.stringify(this.galleries["galleries"][this.name][0]["doors"][i]["mask"]));
        if (curSvg) {
            this.svgFiles.push(curSvg);
        }
      }
    }
  },
  computed: {
    imgSize: function() {
      return this.galleries["galleries"][this.name][0]["imageSize"];
    },
    items: function() {
       return this.galleries["galleries"][this.name][0]["items"];
    },
    doors: function() {
      return this.galleries["galleries"][this.name][0]["doors"];
    }
  },
  created() {
    window.addEventListener("resize", this.updateSvgsSizePos);
    // this.loadImage();
    this.image = window.image_store[this.name]["backgroundImage"];
    this.loadSvgs();
    this.setScaling();
    for (let i = 0; i < this.doors.length; i++) {
      this.isDoorVisible.push(false);
      this.svgSizes.push([0,0]);
      this.setSvgSizePos(i);
    }
  },
  mounted() {
    this.loadDoorImages();
  },
  destroyed() {
    window.removeEventListener("resize", this.updateSvgsSizePos);
  }
};
</script>

<style scoped>

.container-fluid {
  background-repeat: no-repeat;
  background-size: auto 100vh;
  /* height: 100vh; */
}

.overlay {
  background-color: black;
  opacity: 0.2;
  z-index: 2;
}

.fade-enter {
  opacity: 0;
}
.fade-enter-active {
  transition: opacity 1s;
}
.fade-enter-to {
  opacity: 0.2;
}
.fade-leave {
  opacity: 0.2;
}
.fade-leave-active {
  transition: opacity 1s;
}
.fade-leave-to {
  opacity: 0;
}


</style>
